define((require, exports, module) => {
    'use strict';

    const _ = require('lodash');
    const defs = require('./RegistrationStage.defs');
    const RPCModel = require('RPCModel');

    const defaults = {
        currentStage: defs.STAGE_INITIAL,
    };

    const stagesMap = {};

    stagesMap[defs.STAGE_INITIAL] = {
        next: [defs.STAGE_INDIVIDUAL, defs.STAGE_LEGAL],
        back: [],
    };

    stagesMap[defs.STAGE_INDIVIDUAL] = {
        next: [defs.STAGE_FINISH],
        back: [defs.STAGE_INITIAL],
    };

    stagesMap[defs.STAGE_LEGAL] = {
        next: [defs.STAGE_LEGAL_ADDRESS],
        back: [defs.STAGE_INITIAL],
    };

    stagesMap[defs.STAGE_LEGAL_ADDRESS] = {
        next: [defs.STAGE_FINISH],
        back: [defs.STAGE_LEGAL],
    };

    stagesMap[defs.STAGE_FINISH] = {
        next: [],
        back: [],
    };

    const RegistrationStage = RPCModel.extend({
        className: 'MCS.Billing.RegistrationStage',

        defaults,

        stagesMap,

        toStage(stage) {
            this.set('currentStage', stage);
        },

        toNextStage() {
            const currentStage = this.get('currentStage');
            const availableStages = stagesMap[currentStage].next;
            const nextStage = _.first(availableStages);

            this.set('currentStage', nextStage);
        },

        toPreviousStage() {
            const currentStage = this.get('currentStage');
            const previousStages = stagesMap[currentStage].back;
            const previousStage = _.first(previousStages);

            this.set('currentStage', previousStage);
        },
    });

    module.exports = RegistrationStage;
});
